import type { UserSettingsUpdateRequest } from '@lib/requests/user';
import type { UserWithSettingsResponse } from '@lib/responses/user';
import {
  deserializeSuperjson,
  serializeSuperjson,
  SuperJSONResult,
} from '@lib/superjson';

import type { API } from './api';

export class UserService {
  constructor(private api: API) {}

  getUser = async () => {
    const response = await this.api.get<SuperJSONResult>('/user');
    return deserializeSuperjson<UserWithSettingsResponse>(response);
  };

  saveUserProfile = async (data: UserSettingsUpdateRequest) => {
    const serializedData = serializeSuperjson(data);
    const response = await this.api.put<SuperJSONResult>(
      '/user',
      serializedData,
    );
    return deserializeSuperjson<UserWithSettingsResponse>(response);
  };
}
